/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './../app-routing.module';
import { HeaderModule } from './../header/header.module'
import { HelpComponent} from './help.component'

@NgModule({
  declarations: [HelpComponent],
  imports: [BrowserModule,CommonModule, AppRoutingModule, HeaderModule],
  providers: [],
  exports: []
})

export class HelpModule { }
